export default __webpack_public_path__ + "static/logo1-branco-0de1fd1750c9a444eeb52708f42936a6.svg";